import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';

import { catchError, filter, map, switchMap, take } from 'rxjs/operators';
import { format } from 'date-fns';
import { UserService } from '../services/user.service';
import { LoginResp } from 'src/model/User/LoginResp';
import { LoginReq } from 'src/model/User/LoginReq';
import { configObj } from 'src/model/configObj';
import Cookies from 'js-cookie';

@Injectable({ providedIn: 'root' })
export class TokenInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );
  private refreshToken: string = '';
  private jwtToken: string = '';
  private iso8601 =
    /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/;
  LoadingQue = [];
  req:LoginReq = new LoginReq();
  config: configObj;
  constructor(
    private userService: UserService,
    private window: Window,
    private router: Router,
  ) {
    this.config = this.window['config'] as configObj;
    // 修改原先直接取得帳密自動登入的部分
    // this.req.username = this.config.account;
    // this.req.password = this.config.password;
    // this.jwtToken = sessionStorage.getItem('jwt_token');
    // this.userService.loign(this.req).subscribe(data => {
    //   sessionStorage.setItem('jwt_token',data.access_token);
    // });

  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if(!this.jwtToken){

    }
    this.jwtToken = sessionStorage.getItem('jwt_token');
    if (
      this.jwtToken !== null &&
      this.jwtToken !== undefined &&
      this.jwtToken !== ''
    ) {
      req = this.addTokenHeader(req, this.jwtToken);
    }

    req = req.clone({ body: this.convertDateToString(req.body) });

    return  next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.LoadingQue.pop();

          return event;
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        // debugger;
        if (error.status === 401) {
          return this.handle401Error(req, next);
        }
        return throwError(error);
      })
    );
  }

  private handle401Error(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // 遇到 401，不再嘗試自動刷新 token，直接導回登入頁
    sessionStorage.removeItem('jwt_token');
    Cookies.remove('jwt_token')
    this.isRefreshing = false;
    this.refreshTokenSubject.next(null);

    // 導回登入頁
    this.router.navigate(['/login']);  // 確保在 constructor 注入 router

    return throwError(() => new Error('Unauthorized - token invalid or expired'));
  }
  /*
  # 原先使用config 自動登入的方法 
  private handle401Error(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
      let req:LoginReq = new LoginReq();
      req.username = this.config.account;
      req.password = this.config.password;
      debugger;
      return this.userService.loign(req).pipe(
        switchMap((token: LoginResp) => {
          this.isRefreshing = false;
          sessionStorage.setItem('jwt_token', token.access_token);
          this.refreshTokenSubject.next(token.access_token);
          this.jwtToken = token.access_token;
          return next.handle(this.addTokenHeader(request, token.access_token)).pipe(
            map((event: HttpEvent<any>) => {
              if (event instanceof HttpResponse) {
                return event;
              }
              return event;
            })
          );
        }),
        catchError((err) => {
          this.isRefreshing = false;
          return throwError(err);
        })
      );
    }

    return this.refreshTokenSubject.pipe(
      filter((token) => token !== null),
      take(1),
      switchMap((token) =>
        next.handle(this.addTokenHeader(request, token)).pipe(
          map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              return event;
            }
            return event;
          })
        )
      )
    );
  }
  */
  convertToDate(item: any) {
    if (!item) {
      return item;
    }
    if (typeof item !== 'object') {
      return item;
    }
    for (const key of Object.keys(item)) {
      const value = item[key];
      if (this.isIso8601(value)) {
        item[key] = new Date(value);
      } else if (typeof value === 'object') {
        this.convertToDate(value);
      }
    }

    return item;
  }

  isIso8601(value) {
    if (value === null || value === undefined) {
      return false;
    }
    return this.iso8601.test(value);
  }

  convertDateToString(item: any) {
    if (!item) {
      return item;
    }
    if (typeof item !== 'object') {
      return item;
    }
    for (const key of Object.keys(item)) {
      const value = item[key];
      if (value instanceof Date) {
        item[key] = format(value, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx");
      } else if (typeof value === 'object') {
        this.convertDateToString(value);
      }
    }

    return item;
  }

  private addTokenHeader(request: HttpRequest<any>, token: string) {
    return (request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    }));
  }
}
